import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAtomValue } from 'jotai';
import React from 'react';
import styled from 'styled-components/native';
import { currentLocationAtom } from '@/atoms/Location';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { BbucleRoadAccessibilityDtoBbucleRoadTypeEnum, } from '@/generated-sources/openapi';
import ScoreLabel from '@/screens/SearchScreen/components/ScoreLabel';
import { distanceInMeter, prettyFormatMeter } from '@/utils/DistanceUtils';
import { getPlaceAccessibilityScore } from '@/utils/accessibilityCheck';
export default function SearchItemSummary({ item, onPress, }) {
    var _a, _b, _c;
    const currentLocation = useAtomValue(currentLocationAtom);
    const distanceText = (() => {
        let distance;
        if (currentLocation && item.place.location) {
            distance = distanceInMeter(currentLocation, {
                latitude: item.place.location.lat,
                longitude: item.place.location.lng,
            });
        }
        else {
            distance = undefined;
        }
        return prettyFormatMeter(distance);
    })();
    const bbucleRoadData = (_a = item.specialAccessibility) === null || _a === void 0 ? void 0 : _a.bbucleRoadData;
    const bbucleRoadBadgeText = (() => {
        if (!bbucleRoadData)
            return undefined;
        switch (bbucleRoadData.bbucleRoadType) {
            case BbucleRoadAccessibilityDtoBbucleRoadTypeEnum.BaseballStadium:
                return '뿌클로드 야구장 ⚾️';
            case BbucleRoadAccessibilityDtoBbucleRoadTypeEnum.ConcertHall:
                return '뿌클로드 공연장 🎤';
            default: {
                const _exhaustiveCheck = bbucleRoadData.bbucleRoadType;
                return _exhaustiveCheck;
            }
        }
    })();
    return (_jsxs(Container, { elementName: "search_item_summary", onPress: onPress, children: [bbucleRoadBadgeText ? (_jsx(BbucleRoadBadge, { children: _jsx(BbucleRoadBadgeText, { children: bbucleRoadBadgeText }) })) : ((_b = item.accessibilityInfo) === null || _b === void 0 ? void 0 : _b.accessibilityScore) === undefined ? (_jsx(NoInfoText, { children: item.hasPlaceAccessibility
                    ? '건물 입구정보가 필요해요!'
                    : '등록된 정보가 없어요!' })) : (_jsx(ScoreLabel, { score: getPlaceAccessibilityScore({
                    score: (_c = item.accessibilityInfo) === null || _c === void 0 ? void 0 : _c.accessibilityScore,
                    hasPlaceAccessibility: item.hasPlaceAccessibility,
                    hasBuildingAccessibility: item.hasBuildingAccessibility,
                }), isIconVisible: false })), _jsxs(TitleArea, { children: [_jsx(TitleText, { children: item.place.name }), _jsxs(LocationBox, { children: [_jsx(DistanceText, { children: distanceText }), _jsx(LocationDivider, {}), _jsx(AddressText, { children: item.place.address })] })] })] }));
}
const NoInfoText = styled.Text `
  font-size: 12px;
  font-family: ${() => font.pretendardRegular};
  color: ${() => color.gray50};
`;
const BbucleRoadBadge = styled.View `
  background-color: rgba(162, 255, 32, 0.3);
  border-radius: 6px;
  padding: 4px 6px;
  align-self: flex-start;
`;
const BbucleRoadBadgeText = styled.Text `
  font-size: 12px;
  font-family: ${() => font.pretendardMedium};
  color: #305306;
  line-height: 15.6px;
`;
const Container = styled(SccPressable) `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;
const TitleText = styled.Text `
  font-size: 16px;
  font-family: ${() => font.pretendardBold};
  color: ${() => color.black};
`;
const DistanceText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardRegular};
  color: ${() => color.gray80};
`;
const AddressText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardRegular};
  color: ${() => color.gray80};
`;
const LocationBox = styled.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;
const LocationDivider = styled.View `
  width: 2px;
  height: 2px;
  border-radius: 1px;
  background-color: ${() => color.gray80};
`;
const TitleArea = styled.View `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 8px;
`;
